export { default } from './SchoolsMap'
